// extracted by mini-css-extract-plugin
module.exports = {"updateArticle":"UpdateArticle_updateArticle__3-FRm"};